import { ChevronDown } from "lucide-react";

export const CalcSelect = ({ id, label, value, onChange, options }) => (
  <div>
    <label htmlFor={id} className="block text-[11px] font-semibold tracking-[0.2em] uppercase text-titanium mb-3">
      {label}
    </label>
    <div className="relative">
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="calc-input w-full appearance-none rounded-xl px-4 py-3.5 pr-11 font-mono text-sm text-white"
        data-testid={id}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-4 w-4 text-cyan" />
    </div>
  </div>
);

export const CalcSlider = ({ value, onChange }) => (
  <div>
    <div className="flex items-baseline justify-between mb-3">
      <label htmlFor="calc-hires" className="text-[11px] font-semibold tracking-[0.2em] uppercase text-titanium">
        Stima di Assunzioni Annue
      </label>
      <span className="font-mono text-2xl font-semibold text-cyan" data-testid="calc-hires-value">
        {value}
      </span>
    </div>
    <input
      id="calc-hires"
      type="range"
      min="1"
      max="20"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      aria-valuetext={`${value} assunzioni`}
      className="calc-range w-full"
      style={{ "--fill": `${((value - 1) / 19) * 100}%` }}
      data-testid="calc-hires"
    />
    <div className="mt-2 flex justify-between font-mono text-[11px] text-[#5b6068]">
      <span>1</span>
      <span>20</span>
    </div>
  </div>
);
